/* eslint-disable sort-imports */
import { isValidPurchaseDates } from '../../lib/dates';
import { GET_BOOKING_SUCCESS } from '../booking/types';
import extrasReducer from './extrasReducer';
import ticketsReducer from './ticketsReducer';
import transportReducer from './transportReducer';
/* eslint-disable complexity */
import {
  CLEAR_TRANSPORT_DATES,
  CLEAR_TRANSPORT_LOCATIONS,
  CLEAR_TRANSPORT_STOPS,
  GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS,
  GET_ACCOMMODATIONS_SUCCESS,
  GET_ACCOMMODATION_EXTRAS_SUCCESS,
  GET_EXTRAS_AVAILABILITY_SUCCESS,
  GET_EXTRAS_SUCCESS,
  GET_EXTRA_AVAILABILITY_SUCCESS,
  GET_TERMS_CONDITIONS_FAILED,
  GET_TERMS_CONDITIONS_SUCCESS,
  GET_TICKETS_AVAILABILITY_SUCCESS,
  GET_TICKETS_SUCCESS,
  GET_TRANSPORT_DATES_SUCCESS,
  GET_TRANSPORT_LOCATIONS_SUCCESS,
  GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS,
  GET_TRANSPORT_RETURN_STOPS_SUCCESS,
  GET_TRANSPORT_ROUTES_SUCCESS,
  GET_TRANSPORT_STOPS_SUCCESS,
  GET_TRANSPORT_TYPES_SUCCESS,
} from './types';

/**
 * Filter out purchaseable accommodations
 *
 * @param {Object[]} accommodations accommodations
 * @returns {Object[]} state
 */
const filterAccommodations = accommodations =>
  accommodations.filter(({ rooms = [] }) => {
    const validRooms = rooms.filter(({ rules = {} }) => {
      const {
        purchase_start_date = {},
        purchase_end_date = {},
        purchase_dashboard,
      } = rules;

      return (
        purchase_dashboard &&
        isValidPurchaseDates(purchase_start_date, purchase_end_date)
      );
    });

    return validRooms.length > 0;
  });

const initialState = {};

const packageReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING_SUCCESS:
      return {
        ...state,
        [action.payload.booking.reference]: {
          ...state[action.payload.booking.reference],
          ...action.payload.booking.package,
        },
      };

    case GET_ACCOMMODATIONS_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          accommodations: filterAccommodations(action.payload.accommodations),
        },
      };

    case GET_ACCOMMODATIONS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          availability: action.payload.availability,
        },
      };

    case GET_EXTRAS_SUCCESS:
    case GET_ACCOMMODATION_EXTRAS_SUCCESS:
    case GET_EXTRAS_AVAILABILITY_SUCCESS:
    case GET_EXTRA_AVAILABILITY_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          extras: extrasReducer(
            state[action.payload.bookingRef].extras,
            action,
          ),
        },
      };

    case CLEAR_TRANSPORT_DATES:
    case CLEAR_TRANSPORT_LOCATIONS:
    case CLEAR_TRANSPORT_STOPS:
    case GET_TRANSPORT_DATES_SUCCESS:
    case GET_TRANSPORT_LOCATIONS_SUCCESS:
    case GET_TRANSPORT_STOPS_SUCCESS:
    case GET_TRANSPORT_OUTBOUND_STOPS_SUCCESS:
    case GET_TRANSPORT_RETURN_STOPS_SUCCESS:
    case GET_TRANSPORT_TYPES_SUCCESS:
    case GET_TRANSPORT_ROUTES_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          transport: transportReducer(
            state[action.payload.bookingRef]?.transport,
            action,
          ),
        },
      };

    case GET_TICKETS_SUCCESS:
    case GET_TICKETS_AVAILABILITY_SUCCESS:
      return {
        ...state,
        [action.payload.bookingRef]: {
          ...state[action.payload.bookingRef],
          tickets: ticketsReducer(
            state[action.payload.bookingRef].tickets,
            action,
          ),
        },
      };

    case GET_TERMS_CONDITIONS_SUCCESS:
      return {
        ...state,
        termsConditions: action.payload.termsConditions,
      };
    case GET_TERMS_CONDITIONS_FAILED:
      return {
        ...state,
        termsConditions: null,
      };

    default:
      return state;
  }
};

export default packageReducer;
